import { useParams } from "react-router-dom";
import { useUser } from "../contexts/UserContext";

export const useContextDetection = () => {
  const { organizationId, businessUnitId } = useParams();
  const { canManageOrganization, canManageBusinessUnit } = useUser();

  // Determine if we're in organization or business unit context
  const isOrganizationContext = !!organizationId && !businessUnitId;
  const isBusinessUnitContext = !!businessUnitId;

  // Get the appropriate ID and permission check
  const contextId = isOrganizationContext ? organizationId : businessUnitId;
  const contextType = isOrganizationContext ? "organization" : "businessUnit";
  const canManage = isOrganizationContext
    ? canManageOrganization(organizationId)
    : canManageBusinessUnit(businessUnitId);

  return {
    contextId,
    contextType,
    organizationId,
    businessUnitId,
    isOrganizationContext,
    isBusinessUnitContext,
    canManage,
  };
};
